<ul class="daisy-steps daisy-steps-horizontal w-full my-6 text-base-content">
  @for (step of steps; track step; let i = $index) {
    <li
      class="daisy-step text-xs sm:text-sm font-semibold"
      [class.daisy-step-primary]="section >= i + 1"
    >
      {{ step }}
    </li>
  }
</ul>
